"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var LabelVerbosity;
(function (LabelVerbosity) {
    LabelVerbosity["SHORT"] = "short";
    LabelVerbosity["STANDARD"] = "standard";
    LabelVerbosity["LONG"] = "long";
})(LabelVerbosity = exports.LabelVerbosity || (exports.LabelVerbosity = {}));
var LabelPlurality;
(function (LabelPlurality) {
    LabelPlurality["SINGULAR"] = "singular";
    LabelPlurality["PLURAL"] = "plural";
})(LabelPlurality = exports.LabelPlurality || (exports.LabelPlurality = {}));
var UnitLength;
(function (UnitLength) {
    UnitLength["SHORT"] = "short";
    UnitLength["STANDARD"] = "standard";
    UnitLength["LONG"] = "long";
})(UnitLength = exports.UnitLength || (exports.UnitLength = {}));
function isPlural(value) {
    var magnitude = Math.abs(value);
    return magnitude === 0 || magnitude > 1;
}
exports.isPlural = isPlural;
function makePrecise(value, precsion, unitType) {
    if (lodash_1.isNumber(precsion)) {
        return lodash_1.round(value, precsion);
    }
    if (lodash_1.isString(precsion) && unitType === precsion) {
        return lodash_1.round(value, 0);
    }
    return value;
}
exports.makePrecise = makePrecise;
//# sourceMappingURL=index.js.map